import { IconNumbers } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentNumbers';
const links = [
  {
    title: 'My Numbers',
    href: '/numbers/existing',
    activePaths: ['/numbers/:did/details'],
  },
];
const numbersSubNav = () =>
  subNav({
    id: navId,
    title: 'Numbers',
    href: '/numbers',
    icon: IconNumbers,
    links,
  });
export default numbersSubNav;
